import React from 'react';
import LabelWithHelp from '../../Title/LabelWithHelp';
import ContactCard from '../../Contact/ContactCard';

import WordingService from '../../../services/WordingService';

const ContactList = ({ contacts, onContactClick }) => (
    <div>
        <LabelWithHelp
            id="choice-label"
            help={contacts.length > 1 ? WordingService.getWording('hint', 'multipleContacts') : WordingService.getWording('hint', contacts[0].contactType.toLowerCase() === 'm' ? 'mobileContact' : 'mailContact')}
        >
            {WordingService.getWording('title', 'getCode')}
        </LabelWithHelp>
        <ul style={{ padding: 0 }}>
            {contacts.map((contact, key) => <ContactCard key={contact.contactId} number={key} icon={contact.contactType.toLowerCase() === 'm' ? 'messaging' : 'email'} label={contact.contactView} onClick={() => onContactClick(contact)} />)}
        </ul>
    </div>
);

export default ContactList;